/**
 * @author wcd
 * @date 2020/7/29
 * @Description: todo 对象处理工具
 */


export default {

  /**
   * @author wcd
   * @date 2020/7/29
   * @Description: todo null对象转空对象
  */
  nullToEmp(obj) {
    try {
      for (let key in obj) {
        if (obj[key] == null||obj[key] === undefined ||obj[key] === '') {
          obj[key] = {}
        }
      }
      return obj
    } catch (e) {
      return console.error('nullToEmptyObj', e)
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/cdUtils/objTreat.js